module.exports = __webpack_public_path__ + "static/media/uofclogo.a46138ad.png";